import api from 'api/api'
import { toast } from 'react-toastify'
import { urlPdfs } from 'constants/urls'
import { SALE_RETAINER_STATUS } from 'constants/saleRetainers'

export const GET_SALE_RETAINERS = '[SALE_RETAINERS] GET SALE RETAINERS'
export const GET_SALE_RETAINER_BY_ID = '[SALE_RETAINERS] GET SALE RETAINER BY ID'
export const GET_SALE_RETAINERS_FOR_INVOICE_BY_PERSON_ID = '[SALE_RETAINERS] GET SALE RETAINERS FOR INVOICE BY PERSON ID'
export const RESET_SALE_RETAINERS_FOR_INVOICE_BY_PERSON_ID = '[SALE_RETAINERS] RESET SALE RETAINERS FOR INVOICE BY PERSON ID'
export const SAVE_SALE_RETAINER = '[SALE_RETAINERS] SAVE SALE RETAINER'
export const VOID_SALE_RETAINER = '[SALE_RETAINERS] VOID SALE RETAINER'

export function getSaleRetainersAction(filters = { status: SALE_RETAINER_STATUS.FOR_INVOICE, pageSize: 10 }) {
  const request = api.get(`/sale-retainers/registers`, { params: filters })
  return (dispatch) => {
    dispatch({ type: GET_SALE_RETAINERS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_SALE_RETAINERS, payload: { ...response.data.data } })
    }).catch((error) => {
      console.log(GET_SALE_RETAINERS, error)
    }).finally(() => {
      dispatch({ type: GET_SALE_RETAINERS, payload: { loading: false } })
    })
  }
}

export function getSaleRetainerByIdAction(saleId) {
  const request = api.get(`/sale-retainer/${saleId}`)
  return (dispatch) => {
    dispatch({ type: GET_SALE_RETAINER_BY_ID, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: GET_SALE_RETAINER_BY_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_SALE_RETAINER_BY_ID, error)
    }).finally(() => {
      dispatch({ type: GET_SALE_RETAINER_BY_ID, payload: { loading: false } })
    })
  }
}

export function getSaleRetainersForInvoiceByPersonIdAction(personId) {
  const request = api.get(`/sale-retainers/for-invoice/${personId}`)
  return (dispatch) => {
    dispatch({ type: GET_SALE_RETAINERS_FOR_INVOICE_BY_PERSON_ID, payload: { loading: true } })
    request.then((response) => {
      if (parseInt(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: GET_SALE_RETAINERS_FOR_INVOICE_BY_PERSON_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_SALE_RETAINERS_FOR_INVOICE_BY_PERSON_ID, error)
    }).finally(() => {
      dispatch({ type: GET_SALE_RETAINERS_FOR_INVOICE_BY_PERSON_ID, payload: { loading: false } })
    })
  }
}

export function saveSaleRetainerAction(data) {
  const request = api.post(`/sale-retainer/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_SALE_RETAINER, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_SALE_RETAINER, payload: { saved: true, data: response.data.data } })
      window.open(`${urlPdfs.anticipoVentaTicket}/${response.data.data?.anticipo_venta_id}`)
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_SALE_RETAINER, error)
    }).finally(() => {
      dispatch({ type: SAVE_SALE_RETAINER, payload: { saving: false } })
    })
  }
}

export function voidSaleRetainerAction(saleRetainerId) {
  const request = api.post(`/sale-retainer/void/${saleRetainerId}`)
  return (dispatch) => {
    dispatch({ type: VOID_SALE_RETAINER, payload: { voiding_id: saleRetainerId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: VOID_SALE_RETAINER, payload: { voided_id: saleRetainerId } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(VOID_SALE_RETAINER, error)
    }).finally(() => {
      dispatch({ type: VOID_SALE_RETAINER, payload: { voiding_id: saleRetainerId } })
    })
  }
}
